// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__Vu9qu","footer":"ModalFilter_footer__2ZMq2"};